const initialState = {
    isOpen: false,
    product: {},
    inventory: '',
    price: '',
    priceOld: '',
    productKey: 0, // indexe marbut be mahsoolat
};
const modalAddToStock = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_ADD_TO_STOCK':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalAddToStock;
